// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__nXhfQ","actions":"GroupTable_actions__2XHKq","deleteModalFooter":"GroupTable_deleteModalFooter__2i_m7"};